import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (signId?: string) => ({
    id: 'vms-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/vmssigns${signId ? '/' + signId : ''}`,
    displayName: 'Trafikinformationsskyltar',
});

export interface VariableMessageSignProperties {
    publicName: string;
    vmsCssClass: string;
    messageSignVisible: boolean;
    messageSignSource: string;
    roadSignText: string;
    noMessageRowVisible: boolean;
    textRow1: string;
    textRow2: string;
    textRow3: string;
    connectedMessageSignVisible: boolean;
    connectedMessageSignSource: string;
    connectedRoadSignText: string;
    connectedNoMessageRowVisible: boolean;
    url: string;
    iconId?: number;
}

export class VariableMessageSignSource extends AjaxSource {
    constructor(signId?: string, options?: Partial<AjaxSourceOptions>) {
        super({ ...defaultOptions(signId), ...options });
    }
}
